<valio-cx-storefront [class.is-expanded]="isExpanded$ | async">Loading...</valio-cx-storefront>
<div class="cx-spinner modal valio-modal fade " id="valio-spinner">
  <div class="modal-dialog" role="document">
    <cx-spinner></cx-spinner>
  </div>
</div>

<valio-cx-browser-check></valio-cx-browser-check>
